export const packageTypeOptions = [
  { value: "LIMITED", label: "Limited", arabic_label: "محدود" },
  { value: "UNLIMITED", label: "Unlimited", arabic_label: "غير محدود" },
  { value: "CUSTOM", label: "Custom", arabic_label: "مخصص" },
];
